import type {ReactNode} from 'react';

import classnames from 'classnames';

import {colors} from 'shells/colors/colors';
import {CloseHeavyRegularIcon} from 'shells/icon/svg/close-heavy-regular-icon';
import {CloudUploadRegularIcon} from 'shells/icon/svg/cloud-upload-regular-icon';

import type {NutFileInput} from 'nutshell-graphql-types';

import type {PeepType} from '../../../types';

import {FilestackFilePicker} from '../../../../../filestack-file-picker';

import {uploadAvatarOptions} from './consts';

import styles from './peep-avatar-picker.module.css';

interface Props {
    peepType: PeepType;
    hasUploadedAvatar: boolean;
    canDeleteAvatar: boolean;
    children: ReactNode;
    onUploadSuccess?: (file: NutFileInput) => void;
    onRemoveAvatar?: () => void;
}

export function PeepAvatarPicker(props: Props) {
    const overlayClassName = classnames(styles['upload-overlay'], {
        [styles['upload-overlay--account']]: props.peepType === 'account',
        [styles['upload-overlay--contact']]: props.peepType === 'contact',
    });

    return (
        <div className={styles['avatar-container']}>
            {props.children}
            {props.hasUploadedAvatar && props.canDeleteAvatar && props.onRemoveAvatar && (
                <button
                    type='button'
                    className={styles['remove-button']}
                    onClick={(event) => {
                        event.stopPropagation();
                        if (props.onRemoveAvatar) {
                            props.onRemoveAvatar();
                        }
                    }}
                    aria-label='Remove avatar'
                >
                    <div className={styles['remove-button-icon']}>
                        {/* @ts-expect-error */}
                        <CloseHeavyRegularIcon size={14} color={colors.white} wrapWithDiv={false} />
                    </div>
                </button>
            )}
            <FilestackFilePicker
                isMultiSelect={false}
                options={uploadAvatarOptions}
                onSuccess={({filesUploaded}) => {
                    const uploadedFile = filesUploaded[0];
                    if (props.onUploadSuccess && uploadedFile) {
                        props.onUploadSuccess({
                            filename: uploadedFile.filename,
                            filesize: uploadedFile.size,
                            locationUri: uploadedFile.url,
                            mimeType: uploadedFile.mimetype,
                        });
                    }
                }}
                render={({onPick}) => (
                    <button
                        type='button'
                        className={styles['upload-button']}
                        onClick={onPick}
                        aria-label='Upload avatar'
                    >
                        <span className={overlayClassName}>
                            <CloudUploadRegularIcon size={36} />
                        </span>
                    </button>
                )}
            />
        </div>
    );
}
